<template>
  <div class="modal warning fade" :class="{ 'is-open': open }">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <a v-show="!isBox" class="close" @click="$emit('close')"><i class="icon-close"></i></a>
        </div>
        <div class="modal-body">
          <div class="warning">
            <img width="48" :src="`${BaseUrl}assets/common/warning.png`"
              :srcset="`${BaseUrl}assets/common/warning@2x.png`">
            <span class="text" v-html="message"></span>
          </div>

          <!-- 文字區塊 -->
          <div class="info-box" ref="infoBox" @scroll="handleScroll">
            <h3 class="title">{{ mainTitle }}</h3>
            <div class="title-content">{{ titleContent }}</div>
            <div class="subtitle-group" v-for="(item, index) in infoContent" :key="index">
              <h4 class="subtitle" v-html="item.subtitle"></h4>
              <p class="content" v-html="item.content"></p>
            </div>
          </div>

          <!-- Checkbox 區塊 -->
          <div class="row justify-content-center">
            <div class="checkbox checkbox-inline" :class="{ 'is-disabled': !isScrolledToBottom }">
              <input type="checkbox" v-model="confirm_checkbox" id="edit_is_permit" :disabled="!isScrolledToBottom" />
              <label class="text-red custom-label" for="edit_is_permit">
                已確實向客戶(潛在客戶)進行個資告知聲明，並留存同意佐證備查，<br>再建立客戶保單資料／進行資料編輯。
              </label>
            </div>
          </div>

          <!-- 按鈕區塊 -->
          <div class="action text-center">
            <a @click="$emit('send')" class="btn btn-secondary">寄送</a>
            <a @click="$emit('download')" class="btn btn-secondary">下載</a>
            <a @click="doSubmit" class="btn btn-primary">{{ confirmText }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'WarningModal',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    confirmText: {
      type: String,
      default: '確定'
    },
    showCancel: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      mainTitle: "個人資料保護法應告知事項",
      titleContent: "由於您可能是國泰人壽保險股份有限公司(以下稱「本公司」)客戶、潛在客戶、本公司活動參加者或其他與本公司進行服務聯繫(含申訴)相關業務往來關係之人，本公司現在或將來可能因此取得您的個人資料，於本公司所設特定業務目的範圍內，直接或間接蒐集、處理、利用及國內外傳輸您的個人資料。準此，謹請您瞭解本公司依據個人資料保護法(以下稱「個資法」)第八條，向您告知下列事項，請您詳閱：",
      infoContent: [
        {
          subtitle: "一、蒐集之目的：",
          content:
            `（一）人身保險（○○一）。<br>
             （二）其他經營合於營業登記項目或組織章程所定之業務（一八一）。<br>
             （三）消費者、客戶管理及服務（○九○）。<br>
             （四）調查、統計與研究分析（一五七）。<br>
             （五）行銷商品(○四○)與服務。<br>
             （六）消費者保護（九一）。<br>
             （七）民意調查（○二四）。<br>
             （八）契約、類似契約或其他法律關係事務（○六九）。<br>
             （九）金融服務業依法令規定及金融監理需要，所為之蒐集處理及利用<br>
                  <span class="ml-23">（○五九）。</span><br>
             （十）金融爭議處理（○六○）。<br>
             （十一）因活動需要或為提供保險相關服務及資訊而寄送簡訊、推播、傳真、電子<br>
                  <span class="ml-23">郵件給您或致電與您聯繫。</span>
            `
        },
        {
          subtitle: "二、蒐集之個人資料類別：",
          content:
            `蒐集您或您所提供之家人資訊，包括但不限於姓名、性別、年齡、職業、身分證統一編號、生日、聯絡方式(如：通訊地址、電話號碼、電子郵件信箱、偏好聯絡方式)、財務情況(如：信用卡資訊)、及其他得以直接或間接方式識別該個人之資料，具體項目詳客戶關係管理系統(CRM)頁面。`
        },
        {
          subtitle: "三、個人資料利用之期間、對象、地區、方式：",
          content:
            `（一）期間：個人資料蒐集之特定目的存續期間、執行職務或業務所必須及依法令
                  <span class="ml-52">規定應為保存之期間。</span><br>
             （二）對象：本公司、合作廠商(如：服務、行銷供應商)、中華民國人壽保險商業
                  <span class="ml-52">同業公會、業務委外機構、客戶資訊相關作業之委外機構、未受中央</span>
                  <span class="ml-52">目的事業主管機關限制之國際傳輸個人資料之接收者及依法有調查權</span>
                  <span class="ml-52">機關或金融監理機關。</span><br>
             （三）地區：上述對象所在之地區(含國內及國外)。<br>
             （四）方式：合於法令規定之利用方式。`
        },
        {
          subtitle: `四、依據個資法第三條規定，您就本公司保有您的個人
                    <span class="ml-25">資料得行使之權利及方式：</span>`,
          content:
            `（一）得向本公司行使之權利：<br>
               <span class="ml-26">1. 向本公司查詢、請求閱覽或請求製給複製本。</span><br>          
               <span class="ml-26">2. 向本公司請求補充或更正。</span><br>
               <span class="ml-26">3. 向本公司請求停止蒐集、處理或利用及請求刪除。惟因執行職務或業務</span>
                  <span class="ml-35">所必須之個人資料，本公司依個資法第十一條規定，得不同意您的請求。</span><br>
             （二）行使權利之方式：您可至本公司各服務據點，或撥打本公司免付費專線
               <span class="ml-26">（0800-036-599）詢問，本公司將儘速依相關法令規定，處理與回覆您</span>
               <span class="ml-26">的請求</span>`
        },
        {
          subtitle: "五、不提供個人資料所致權益之影響：",
          content:
            `您若未能提供相關個人資料時，本公司將可能延後或無法進行保單規劃及處理作業，或無法獲得本公司提供之相關服務及資訊或本公司可能遲延提供您相關服務，敬請諒察。`
        },
      ],
      confirm_checkbox: false,
      isScrolledToBottom: false //紀錄滾動條是否已滾動至最底部
    }
  },
  watch: {
    open(newVal) {
      if (newVal) {
        document.body.style.overflow = "hidden"; // 禁用滾動

        this.confirm_checkbox = false;
        this.isScrolledToBottom = false;

        // 確保 DOM 渲染後，滾動條拉回最上方。
        this.$nextTick(() => {
          if (this.$refs.infoBox) {
            this.$refs.infoBox.scrollTop = 0;
            this.checkIfScrollbarExist();
          }
        })
      } else {
        document.body.style.overflow = ""; // 恢復滾動
      }
    },
    message() {
      this.registerHanlink()
    },
  },
  computed: {
    ...mapGetters(["UserInfo", "BaseUrl"]),
    isBox() {
      // 判斷是否為 box
      return this.UserInfo.userType === "box";
    }
  },
  methods: {
    handleScroll(e) {
      if (this.isScrolledToBottom) return;

      const target = e.target;
      // Math.abs() <= 2 給瀏覽器2px的容許誤差。消除瀏覽器縮放時產生的小數點誤差
      const isBottom = Math.abs(target.scrollHeight - target.scrollTop - target.clientHeight) <= 2;

      if (isBottom) {
        this.isScrolledToBottom = true;
      }
    },
    checkIfScrollbarExist() {
      const target = this.$refs.infoBox;
      if (target) {
        if (target.scrollHeight <= target.clientHeight) {
          this.isScrolledToBottom = true;
        }
      }
    },
    doSubmit() {
      if (!this.confirm_checkbox) {
        this.$toast.info({ title: '未經客戶同意編輯資料' })
        return
      }
      this.$emit('submit')
    }
  }
}
</script>

<style scoped>
.info-box {
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 16px;
  max-height: 350px;
  overflow-y: auto;
  margin: 16px 0;
  scrollbar-color: #bdbebd transparent;
}

.info-box .title {
  text-align: center;
  color: #396337;
  font-size: 26px;
  font-weight: bold;
  margin-top: 15px;
}

.info-box .subtitle-group {
  margin-bottom: 16px;
}

.info-box .subtitle {
  color: #85b168;
  font-weight: bold;
  margin-bottom: 8px;
}

.info-box .title-content,
.info-box .content {
  color: #000;
  font-size: 14px;
  line-height: 1.6;
}

.checkbox .text-red {
  color: red;
}

.action {
  margin-top: 16px;
}

.action a {
  margin: 0 8px;
  padding: 8px 16px;
}

.btn-secondary {
  background-color: #548235;
  color: white;
  border: 1px solid#476b2d;
  border-radius: 4px;
}

.btn-secondary:hover {
  background-color: #679f41;
}

.modal.is-open {
  display: block;
}

.modal.fade .modal-dialog.modal-sm {
  margin: 8% auto !important;
}

/deep/ .ml-23 {
  margin-left: 2.3rem !important;
}

/deep/ .ml-25 {
  margin-left: 2.5rem !important;
}

/deep/ .ml-26 {
  margin-left: 2.6rem !important;
}

/deep/ .ml-35 {
  margin-left: 3.5rem !important;
}

/deep/ .ml-52 {
  margin-left: 5.2rem !important;
}

.modal.fade .modal-header {
  padding: 5px !important;
}

.checkbox>input+label.custom-label {
  display: inline-flex;
  align-items: flex-start;

  height: auto;
  line-height: 1.5;

  padding-top: 2px;
  padding-bottom: 5px;
}

.checkbox.is-disabled input+label.custom-label::before {
  cursor: not-allowed;
  border-color: #ccc !important;
  background-color: #f5f5f5 !important;
  background-image: none !important;
}

.checkbox.is-disabled label.custom-label {
  cursor: default;
}
</style>
